import React from 'react';
import '../../../assets/styles/PrivacyPolicy.css';
import Navbar from '../../../components/AuctionFeatureComponents/Home/Navbar';

const TermsOfService = () => {
  return (
    <>
      <Navbar />
      <div className="container-fluid mt-5 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="privacy-policy-content">
              <h1 className="text-center mb-5">Terms of Service</h1>
              
              <p className="text-muted mb-4">
                <strong>Last Updated:</strong> September 2025
              </p>
              
              <p>
                Welcome to MyLiveAuction ("we," "our," "us"), a live auction platform designed for organizing and participating in player auctions across various sports. These Terms of Service govern your access to and use of our platform at <a href="https://myliveauction.com">https://myliveauction.com</a> (the "Website").
              </p>
              
              <p>
                By accessing or using MyLiveAuction, you agree to these Terms of Service. If you do not agree, please stop using our platform.
              </p>
              
              <h2>1. Information We Collect</h2>
              <p>
                We collect information to provide and improve our services, facilitate auctions, and ensure secure access.
              </p>
              
              <h3>1.1 Information You Provide</h3>
              <ul>
                <li>
                  <strong>Account Information:</strong> Name, email, mobile number, and password when registering.
                </li>
                <li>
                  <strong>Auction Information:</strong> Sport, date, team names, budgets, and auction configurations.
                </li>
                <li>
                  <strong>Player Data:</strong> Names, base prices, categories, and related details when adding players.
                </li>
                <li>
                  <strong>Team Data:</strong> Team details, owner names, and bidding preferences.
                </li>
                <li>
                  <strong>Support Requests:</strong> When you contact us for help, we collect your name, contact details, and message.
                </li>
              </ul>
              
              <h3>1.2 Automatically Collected Information</h3>
              <ul>
                <li>
                  <strong>Usage Data:</strong> IP address, browser type, operating system, device info, and access times.
                </li>
                <li>
                  <strong>Analytics Data:</strong> We use tools (like Google Analytics) to understand how users interact with our platform.
                </li>
              </ul>
              
              <h3>1.3 Cookies</h3>
              <p>
                We use cookies to maintain user sessions, preferences, and improve user experience. You can disable cookies in your browser settings, but some features may not function properly.
              </p>
              
              <h2>2. How We Use Your Information</h2>
              <p>We use your data to:</p>
              <ul>
                <li>Create and manage your account</li>
                <li>Enable auction creation, registration, and live bidding</li>
                <li>Display real-time updates and leaderboard data</li>
                <li>Communicate updates, reminders, and notifications</li>
                <li>Provide customer support and resolve issues</li>
                <li>Improve platform performance and features</li>
                <li>Comply with legal requirements and prevent fraud</li>
              </ul>
              <p>We do not sell your personal data to third parties.</p>
              
              <h2>3. Sharing and Disclosure</h2>
              <p>We may share information only when necessary:</p>
              <ul>
                <li>
                  <strong>With Service Providers:</strong> For hosting, analytics, or technical support (bound by confidentiality agreements).
                </li>
                <li>
                  <strong>With Organizers:</strong> Limited data shared for team/auction management purposes.
                </li>
                <li>
                  <strong>Legal Compliance:</strong> If required by law, regulation, or court order.
                </li>
              </ul>
              <p>We do not publicly display sensitive user data without consent.</p>
              
              <h2>4. Data Security</h2>
              <p>
                We use industry-standard security measures (encryption, HTTPS, secure access control) to protect your data.
                However, no online platform is 100% secure. Users are responsible for safeguarding their login credentials.
              </p>
              
              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and review your personal data</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your data (subject to retention obligations)</li>
                <li>Withdraw consent at any time</li>
              </ul>
              <p>To exercise these rights, contact us using the details below.</p>
              
              <h2>6. Data Retention</h2>
              <p>
                We retain your data only as long as necessary for:
              </p>
              <ul>
                <li>Active auctions and team operations</li>
                <li>Legal, accounting, or reporting requirements</li>
              </ul>
              <p>
                Once your account is deleted, associated auction and player data may be anonymized or removed.
              </p>
              
              <h2>7. Third-Party Links</h2>
              <p>
                Our platform may include links to third-party sites (e.g., YouTube, payment gateways). We are not responsible for the privacy practices or content of those sites. Please review their policies before interacting.
              </p>
              
              <h2>8. Children's Privacy</h2>
              <p>
                MyLiveAuction is intended for users 13 years and older. We do not knowingly collect personal data from children under 13. If you believe we've collected such data, contact us for immediate removal.
              </p>
              
              <h2>9. Changes to This Policy</h2>
              <p>
                We may update this Terms of Service from time to time. Updates will be posted on this page with a revised date. Continued use of MyLiveAuction after changes indicates acceptance.
              </p>
              
              <h2>10. Contact Us</h2>
              <p>If you have any questions, concerns, or requests related to these Terms of Service, please reach out to us:</p>
              
              <div className="contact-info">
                <p><strong>MyLiveAuction Support Team</strong></p>
                <p>📧 Email: <a href="mailto:contact.myliveauction@gmail.com">contact.myliveauction@gmail.com</a></p>
                <p>📞 Available Hours: 9 AM – 9 PM MST</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      {/* <footer className="bg-dark text-white text-center py-4 mt-5">
        <div className="container">
          <p>© 2025 LiveAuction. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy-policy">Privacy Policy</a> | 
            <a href="/terms-of-service"> Terms of Service</a> |
            <a href="/#footer"> Contact Us</a>
          </div>
        </div>
      </footer> */}
    </>
  );
};

export default TermsOfService;